import type { RouteRecordRaw } from "vue-router";

/** Auth público vive en Site/routes (PublicLayout). */
export const publicRoutes: RouteRecordRaw[] = [];
